<template>
  <b-row class="app-section p-4">
    <b-col cols="2" class="h-100 p-0">
      <!-- TODO: incorporate the Fuse.js search functionality
      in the future. All search implementation is commented out
      for now -->
      <!-- <div class="mb-1 mt-2">
        <span style="color: black; font-weight: bold"
          >Filter List of Instruments&nbsp;</span
        >
        <i
          class="fas fa-info-circle"
          v-b-popover.hover.bottom="filterHoverContent"
          title="Filter the list of instruments"
        ></i>
      </div> -->
      <!-- <label class="mr-2 mb-1 mt-2">Search</label>
      <b-form-input
        class="mb-2"
        type="text"
        v-model="search"
        placeholder="Search insts"
      >
      </b-form-input>
      {{searchCheck}} -->
      <b-card
        class="instrument-filter p-0"
        no-body
        style="border: none;"
        body-class="instrument-filter-container"
      >
        <b-container class="instrument-filter-sidebar">
          <div class="row" v-for="(collapse, index) in collapses" :key="index">
            <div class="col-12 p-0">
              <b-button
              style="font-size: 0.9375em;"
                block
                @click="collapse.show = !collapse.show"
                variant="primary"
              >
                {{ collapse.name }} <i class="fas fa-angle-down"></i>
              </b-button>
              <b-collapse v-model="collapse.show" id="collapse-1" class="mt-2">
                <b-card v-if="collapse.name === 'Instrument Group'">
                  <b-form-group>
                    <b-form-checkbox-group
                      id="checkbox-group-1"
                      stacked
                      class="mr-0"
                      v-model="selectedGroup"
                      :options="groupCheckboxes"
                      name="flavour-1"
                      style="font-size: 0.875em;"
                    ></b-form-checkbox-group>
                    <!--Disables btn if there is no selected group-->
                    <b-button
                    style="font-size: 0.875em;"
                      block
                      :disabled="selectedGroup < 1"
                      @click="resetSelection()"
                      variant="primary"
                    >Reset Selection</b-button>
                  </b-form-group>
                </b-card>
              </b-collapse>
            </div>
          </div>
        </b-container>
      </b-card>
    </b-col>
    <!-- End of filter -->
    <b-col cols="10">
      <b-row style="height: 100%">
        <b-col class="h-100">
          <b-form inline>
            <label class="mr-2 mb-1 mt-2" for="inline-form-sort">Sort by</label>
            <b-form-select
              id="inline-form-sort"
              v-model="selected"
              :options="options"
              class="mb-1 mt-2">
            </b-form-select>
          </b-form>
          <br>
          <!-- Pagination on the card listing so it is easier for
          users to go through all the instruments -->
          <b-pagination
            class="inst-cards-list"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="inst-cards-list"
            size="sm"
            align="left"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
          ></b-pagination>
          <!--Skeleton wrapper holding list of empty cards with skeleton element-->
          <b-skeleton-wrapper v-if="loading">
             <b-card-group deck>
               <!--skeletonCardNum defined in data-->
              <b-card
                style="min-width: 25rem; margin: 1rem;"
                v-for="i in skeletonCardNum"
                :key="`${i}--instSkeletonCard`"
              >
                <div>
                  <b-skeleton-icon
                    class="b-skeleton-icon-wrapper"
                    icon="server"
                    :icon-props="{ fontScale: 1, variant: 'primary' }"
                  ></b-skeleton-icon>
                  <b-skeleton class="ml-4" width="45%"></b-skeleton>
                </div>
                <br>
                <b-skeleton width="85%"></b-skeleton>
                <b-skeleton width="55%"></b-skeleton>
                <template #footer>
                  <div style="display: inline;">
                    <b-skeleton type="button"></b-skeleton>
                  </div>
                </template>
              </b-card>
             </b-card-group>
          </b-skeleton-wrapper>
          <instrument-card :instruments="instList"></instrument-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
import InstrumentPageCardVue from './instrumentPageCard';

export default {
  components: {
    'instrument-card': InstrumentPageCardVue,
  },
  data() {
    return {
      responseObj: [],
      instruments: [],
      perPage: 9, // displays max 9 on a page
      currentPage: 1,
      instList: [],
      // search: '',
      // searchCheck: [],
      instrumentsAlphaAtoZ: [],
      instrumentsAlphaZtoA: [],
      instrumentsSizeHtoL: [],
      instrumentsSizeLtoH: [],
      tabIndex: 0,
      loading: false,
      skeletonCardNum: 50, // to give illusion of all the cards loading onto the page
      selected: 'atz',
      options: [
        { value: 'atz', text: 'Alphabetical: A to Z' },
        { value: 'zta', text: 'Alphabetical: Z to A' },
        { value: 'lth', text: 'Data Size: Low to High' },
        { value: 'htl', text: 'Data Size: High to Low' },
      ],
      filterHoverContent:
        'Select a site, infrastructure, and/or instrument of interest by clicking one below.',
      selectedGroup: [], // Selections must be an array reference!
      groupCheckboxes: [],
      collapses: [
        { show: true, name: 'Instrument Group' }, // site filter starts open, not closed
      ],
    };
  },
  mounted() {
    this.loading = true;
    this.retrieveInstrumentInfo();
  },
  // TODO: incorporate the Fuse.js search functionality in the future
  // All search implementation is commented out for now
  // computed: {
  //  searchCheck() {
  //     return _.filter(this.instruments, post => {
  //       return post.name.toLowerCase().includes(this.search.toLowerCase()) ||
  //       post.formal_name.toLowerCase().includes(this.search.toLowerCase()) ||
  //       post.group.toLowerCase().includes(this.search.toLowerCase());
  //     });
  //   },
  // },
  watch: {
    // Updates the card listing based on what sort selection is
    selected(newVal) {
      this.getSelection(newVal);
    },
    // Watches for new checkbox slections for side menu
    selectedGroup(newVal) {
      this.getSelection(newVal);
    },
    currentPage() {
      this.filterList();
    },
  },
  computed: {
    rows() {
      return this.instruments.length;
    },
  },
  methods: {
    retrieveInstrumentInfo() {
      axios
        .get('https://ooi-data.s3.us-west-2.amazonaws.com/index.json')
        .then((response) => {
          this.responseObj = response.data;
          this.getSelection(this.selected);
          this.filterInstruments();
        });
    },
    // Splits the listing of posts into groupings of 9 per page
    filterList() {
      const indexStart = (this.currentPage - 1) * this.perPage;
      const indexEnd = this.perPage * this.currentPage;
      this.instList = this.instruments.slice(indexStart, indexEnd);
    },
    // Filters the instruments from axios call to only get all the groups available
    filterInstruments() {
      const instsData = this.responseObj.instruments;
      const instsGroup = [];
      let mappedInstListing = [];
      // Gets all the instrument objects that are within the response.data
      instsData.forEach((o) => {
        instsGroup.push(o);
      });
      // Maps the checkbox texts and values
      mappedInstListing = instsGroup.map((feat) => ({
        text: feat.group,
        value: feat.group,
      }));
      // Removes any duplicates
      const rmInstDuplicates = _.uniqBy(mappedInstListing, 'value');
      // Puts list in alphabetical order
      const sortInstList = _.sortBy(rmInstDuplicates, ['text']);
      this.groupCheckboxes = sortInstList;
    },
    getSelection(selectionInput) {
      const allInstListing = this.responseObj.instruments;
      // checks if the user is changing the instrument listing from the sort
      if (_.isString(selectionInput)) {
        // if the user has removed all the selections
        if (_.isEmpty(this.selectedGroup)) {
          const sortedListing = this.sortListing(allInstListing);
          this.instruments = sortedListing;
        } else { // will sort the listing if it has already been filtered by sidemenu
          const tempListing = this.instruments;
          const sortedListing = this.sortListing(tempListing);
          this.instruments = sortedListing;
        }
        // checks if user is changing the instrument listing from the sidemenu
      } else if (_.isArray(selectionInput)) {
        // if the user has removed all the selections
        if (_.isEmpty(this.selectedGroup)) {
          this.resetSelection();
        } else { // user is selecting 1 or more groups, it will filter the listing
          const filterInstListing = [];
          selectionInput.forEach((instGroup) => {
            allInstListing.forEach((feat) => {
              if (instGroup === feat.group) {
                filterInstListing.push(feat);
              }
            });
          });
          const filterListing = this.sortListing(filterInstListing);
          this.instruments = filterListing;
        }
      }
      this.filterList(); // calls each time instruments is filtered
      this.loading = false;
    },
    // performs the formating for the sort (alphabetical and data size)
    sortListing(instListing) {
      let sortedInstListing = [];
      if (this.selected === 'atz') {
        sortedInstListing = _.sortBy(instListing, 'formal_name');
      } else if (this.selected === 'zta') {
        sortedInstListing = _.reverse(_.sortBy(instListing, 'formal_name'));
      } else if (this.selected === 'lth') {
        sortedInstListing = _.sortBy(instListing, 'total_bytes');
      } else if (this.selected === 'htl') {
        sortedInstListing = _.reverse(_.sortBy(instListing, 'total_bytes'));
      }
      return sortedInstListing;
    },
    resetSelection() {
      // if user clicks 'reset selection' checks if the selectedGroup is empty
      // if it is not empty, then this will programmatically deselect any
      // checkboxes that have been selected
      if (!_.isEmpty(this.selectedGroup)) {
        this.selectedGroup = [];
      }
      const allInstListing = this.responseObj.instruments;
      const sortedListingGroup = this.sortListing(allInstListing);
      this.instruments = sortedListingGroup;
    },
  },
};
</script>
<style>
.b-skeleton-icon-wrapper {
  position: absolute !important;
}
</style>
